import createKeyframeAnimation from "./keyframes";
var cached = {};

var getAnimationNames = function getAnimationNames(easeName, ratioX, ratioY) {
  var key = easeName.replace(/\s+/g, "") + "_" + ratioX.toFixed(5).replace(".", "_") + "x" + ratioY.toFixed(5).replace(".", "_");

  if (!cached[key]) {
    createKeyframeAnimation(ratioX, ratioY, easeName, key);
    cached[key] = true;
  }

  return {
    name: key,
    inverseName: key + "_inv"
  };
};

export default getAnimationNames;